import React from 'react';
import EventPage from '../Components/Events/EventPage';
import { Navbar, Footer } from '../Components/Home/layout';

const Event = () => (
  <>
    <Navbar />
    <EventPage />
    <Footer />
  </>
);

export default Event;
